import { openDrawer } from 'features/app/appSlice';
import { DRAWER_WIDTH } from 'utils/constants';
import Drawer from '@mui/material/Drawer';
import { useAppDispatch } from 'hooks/useAppStore';
import useConfig from 'hooks/useConfig';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

// ==============================|| COMPONENT ||============================== //

const DrawerStyled = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { drawerOpen, onChangeDrawerOpen } = useConfig();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Drawer
      variant={matchUpMd ? 'persistent' : 'temporary'}
      anchor='left'
      open={drawerOpen}
      onClose={() => {
        dispatch(openDrawer(!drawerOpen));
        onChangeDrawerOpen(!drawerOpen);
      }}
      sx={{
        '& .MuiDrawer-paper': {
          mt: matchDownMd ? 0 : 11,
          zIndex: 1099,
          width: DRAWER_WIDTH,
          background: theme.palette.background.default,
          color: theme.palette.text.primary,
          borderRight: 'none'
        }
      }}
      ModalProps={{ keepMounted: true }}
      color='inherit'
    >
      {children}
    </Drawer>
  );
};

export default DrawerStyled;
